/**
 * Program: SDL Common Component
 * Author: SDL
 * Description: SDL Common Component
 */
import SdlBreadcrumb from './breadcrumb';
import SdlLoadingbar from './loadingbar/LoadingBar';
import SdlModal from './modal';
import SdlFileuploader from './fileuploader/MultipleFileUploader';
import SdlDatePicker from './datepicker';
import SdlRegexInput from './input/RegexInput';
import SdlTabsPlugin from './tabs';
import sdlPagination from './pagination/Pagination';
import { SdlExceldownload, SdlExcelupload } from './excel';
import SdlTree from './tree';
import SdlApprovalpath from './approvalpath/ApprovalPath';
import SdlCheckbox from './checkbox/Checkbox';
import SdlRadio from './radio/Radio';

const SdlControl = {
  // eslint-disable-next-line no-unused-vars
  install(Vue, options) {
    Vue.use(SdlModal, {
      dialog: true,
      dynamic: true,
      dynamicDefaults: { clickToClose: false },
      injectModalsContainer: true,
    });

    Vue.use(SdlTabsPlugin);

    Vue.component('sdl-breadcrumb', SdlBreadcrumb);
    Vue.component('sdl-loadingbar', SdlLoadingbar);
    Vue.component('sdl-fileuploader', SdlFileuploader);
    Vue.component('sdl-datepicker', SdlDatePicker);
    Vue.component('sdl-pagination', sdlPagination);
    Vue.component('sdl-exceldownloadbtn', SdlExceldownload);
    Vue.component('sdl-exceluploadbtn', SdlExcelupload);
    Vue.component('sdl-tree', SdlTree);
    Vue.component('sdl-approvalpath', SdlApprovalpath);
    Vue.component('sdl-regex-input', SdlRegexInput);
    Vue.component('sdl-checkbox', SdlCheckbox);
    Vue.component('sdl-radio', SdlRadio);
    // Exclude Editor from SDL common component related to license
    // Vue.component('sdl-editor', SdlEditor);
  },
};

export default SdlControl;



// WEBPACK FOOTER //
// ./src/components/common/control/index.js